import { render } from "./ContentEditComponent.vue?vue&type=template&id=4d5bf1ca&scoped=true"
import script from "./ContentEditComponent.vue?vue&type=script&lang=js"
export * from "./ContentEditComponent.vue?vue&type=script&lang=js"

import "./ContentEditComponent.vue?vue&type=style&index=0&id=4d5bf1ca&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5bf1ca"]])

export default __exports__